module.exports = __webpack_public_path__ + "img/grid.0f4eb59f.png";